import { useSelector } from "@grandvisionhq/state";
import { getSelectedPickupPoint, getSelectedStore } from "../../../../../../../../../../StepShipping/StepShipping/selectors.js";
import { mapGVShippingMethodToApplePayShippingType } from "../../../../../../mappers/modules/ExpressCheckout/hooks/apple-pay/mappers/apple-pay-shipping-types.js";
import { mapPickupPointToApplePayShippingContact } from "../../../../../../mappers/modules/ExpressCheckout/hooks/apple-pay/mappers/pickup-point-to-apple-shipping-contact.js";
import { mapStoreToApplePayShippingContact } from "../../../../../../mappers/modules/ExpressCheckout/hooks/apple-pay/mappers/store-to-apple-shipping-contact.js";
import { ShippingMethod } from "../../../../../../../../../../models/step-shipping/models/step-shipping/shipping-methods.js";
const useMapShippingContact = (cart) => {
  const selectedPickupPoint = useSelector(getSelectedPickupPoint);
  const selectedServiceStore = useSelector(getSelectedStore);
  const shippingMethod = cart?.shippingMethod.key;
  const isPickupPointSelected = shippingMethod === ShippingMethod.PickupPoint && !!selectedPickupPoint;
  const isStorePickUpSelected = shippingMethod === ShippingMethod.Pickup && !!selectedServiceStore;
  let shippingContact;
  if (isPickupPointSelected) {
    shippingContact = mapPickupPointToApplePayShippingContact(selectedPickupPoint);
  }
  if (isStorePickUpSelected) {
    shippingContact = mapStoreToApplePayShippingContact(selectedServiceStore);
  }
  return {
    shippingContact,
    shippingContactEditingMode: isPickupPointSelected || isStorePickUpSelected ? "storePickup" : "enabled",
    shippingType: mapGVShippingMethodToApplePayShippingType(shippingMethod)
  };
};
export {
  useMapShippingContact
};
//# sourceMappingURL=use-map-shipping-contact.js.map
